export interface S3StorageInfo {
    s3Bucket: string;
    s3Key: string;
    statusId: VideoStatusId;
    storage: string;
}

export enum VideoStatusId {
    COMPLETE = 'COMPLETE',
    ERROR = 'ERROR',
    IN_PROCESS = 'IN_PROCESS',
}
